import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW} from "@utils/CalVW.tsx";

export const AssetTotalValueLeftSection = styled.div`
  width: 50%;
  padding-left: 40px;

    @media ${media.mobile} {
        width: 100%;
        padding-left: ${MobileCalVW(20)};
    }
`;
export const AssetTotalValueRightSection = styled.div`
	width: 50%;
	height: 100%;
	padding-right: 40px;
	display: flex;
	justify-content: flex-end;
    padding-bottom: 90px;


    @media ${media.mobile} {
        width: 100%;
        height: 0;
        padding-bottom: 0;
        justify-content: start;
        margin-top: 50px;
        margin-left: ${MobileCalVW(20)};
        margin-bottom: 20px;
    }
`
